import { Avatar, Button, Checkbox, Drawer, Input, message, Popover, Radio, Select } from 'antd';
import { useEffect, useRef, useState } from 'react';

import { EyeOutlined, PlusOutlined } from '@ant-design/icons';
import competition from '../../data/competition';
import { t } from '../../languages';
import { recordPageGA } from '../../modules/ga';
import { AGE } from '../../modules/user';
import SubscribeButton from '../Subscription/SubscribeButton';
import { generateAnimalsSeries, generateChallNumberSeries, generateCompleteEquationSeries, generateCompleteEquationsSeries, generateMemoSeries, generateMultDivSeries, generateNumPathSeries, generateTuples, getSumSubSeries } from '../gamez/utils';

const MAX_EXERCISES = 10;
const LIMITLEVEL = 3;

const PreviewExercise = ({ lang, impl }) => {
    return <Popover title={<strong>{t(lang, 'example')}</strong>} placement="topRight" content={<img src={`./static/previews/${impl}.png`} />} trigger="click"><EyeOutlined /></Popover>;
}

const SelectExerciseTitle = ({ lang, onClose, handleChange, levels }) => {

    const filterOptions = [
        {
            disabled: true,
            value: 'filter',
            label: t(lang, 'filter')
        },
        {
            value: 0,
            label: t(lang, 'all')
        },
    ];

    if (levels && levels.length) {
        levels.forEach(lv => {
            const levelTitle = (typeof lv.level === "number") ? `${t(lang, 'level')} ${lv.level}` : t(lang, lv.level);
            filterOptions.push({ value: lv.level, label: levelTitle });
        });
    }


    return <div className='select-exercises-title'>
        <div>
            <span>{t(lang, 'addExercise')}</span> <Button className='button-white' onClick={onClose}>{t(lang, 'ready')}</Button>
        </div>
        <div className='links'>
            <Select
                defaultValue="filter"
                style={{ width: 120 }}
                onChange={handleChange}
                options={filterOptions}
            />
        </div>
    </div>;
}

const SelectExercises = ({ lang, open, onClose, theClass, currentPlan, chosenExercises, handleExerciseChecked, hasTeacherSubscription }) => {
    // console.log(`SelectExercises currentPlan:`, currentPlan);

    const [levelToFilter, setLevelToFilter] = useState(null);

    const filterByOption = (value) => {
        console.log(`filterByOption:`, value);
        setLevelToFilter(value);
    }

    return <Drawer className="teach-drawer select-exercises"
        title={<SelectExerciseTitle lang={lang} onClose={onClose} levels={currentPlan} handleChange={filterByOption} />}
        placement="right"
        open={open}
        onClose={onClose}
    >
        {theClass ? <h2><Avatar src={`./static/ages/age_${theClass.age}.svg`} /> {AGE[theClass.age]}</h2> : null}
        {currentPlan.map((aL, idx) => {
            if(levelToFilter && levelToFilter != 0 && aL.level != levelToFilter) return null;
            
            const activeLevel = (hasTeacherSubscription || (!hasTeacherSubscription && aL.level < LIMITLEVEL)) ? true : false;
            const levelTitle = (typeof aL.level === "number") ? `${t(lang, 'level')} ${aL.level}` : t(lang, aL.level);

            return <ul key={aL.level} className={`${activeLevel ? '' : 'gray'}`}>
                {aL.level == LIMITLEVEL && !activeLevel ? <SubscribeButton lang={lang} show={false} forTeach={true} /> : null}
                <h3>{levelTitle}</h3>
                {aL.units.map(aU => {
                    if (aU.label == 'strengthenlearnt') return aU.exercises.map(aE => {
                        const exerChosen = chosenExercises.find(cEx => ((cEx.label == aE.label && cEx.level == aL.level)));
                        let impl = aE.impl;
                        if (impl === 'multiplydivide') {
                            if (aE.params.ops.includes('*')) impl += '_mult';
                            else impl += '_div';
                        }
                        return <li key={aE.label}>
                            <Checkbox disabled={!activeLevel} checked={exerChosen} onChange={(elem) => handleExerciseChecked(elem.target.checked, aE, aL.level)}> {t(lang, aE.label)}</Checkbox> <PreviewExercise lang={lang} impl={impl} />
                        </li>;
                    });
                    else return <h4 key={aU.label}>{t(lang, aU.label)}. </h4>;
                })}
            </ul>;
        })}
    </Drawer>
}

const CreateCompetition = ({ lang, classes, hasTeacherSubscription, onCreate }) => {
    const [competitionName, setCompetitionName] = useState('');
    const [theClass, setTheClass] = useState(null);
    const [currentPlan, setcurrentPlan] = useState(null);
    const [isValid, setIsValid] = useState(false);
    const [open, setOpen] = useState(false);
    const [chosenExercises, setChosenExercises] = useState([]);

    // Registro en Google Analytics
    useEffect(() => {
        recordPageGA('/create-competition');
    }, []);

    // Validación en tiempo real
    useEffect(() => {
        setIsValid(competitionName.trim().length >= 2 && theClass && chosenExercises && chosenExercises.length);
        // const _theClass = classes.find(aC => aC.id == theClass);
        const age = theClass && theClass.age ? theClass.age : 1;
        // console.log('CreateCompetition theClass:', theClass);

        const newPlan = JSON.parse(JSON.stringify(competition[age]));
        setcurrentPlan(newPlan);
    }, [competitionName, theClass, chosenExercises]);

    const handleCreate = () => {
        if (isValid) {
            onCreate({ name: competitionName.trim(), class: theClass.id, exercises: chosenExercises });
        }
    };

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const handleExerciseChecked = (checked, exer, level) => {
        // console.log(`handleExerciseChecked:`, checked, exer, level);

        let _chosenExercises = [...chosenExercises];
        exer.level = level;
        if (checked) {
            if (chosenExercises.length >= MAX_EXERCISES) {
                message.warning(t(lang, 'max_exers_reached'), 2);
            } else {
                // Configure unique exercise params
                const exerParams = exer.params;
                const origNum = exerParams.num;
                exerParams.num = 1;
                exerParams.isCompetition = true;

                if (exerParams.levels) exerParams.levels = exerParams.levels.slice(-1);
                if (Array.isArray(exerParams.couples)) {
                    exerParams.couples = [exerParams.couples[Math.floor(Math.random() * exerParams.couples.length)]];
                } else if (exerParams.couples == 'random') {
                    if (['memoset'].includes(exer.impl) && !exerParams.memoseries) {
                        if (!exerParams.series) exerParams.num = origNum;
                        exerParams.memoseries = generateMemoSeries(exerParams);
                    } else if (['mentalsumsubstraction', 'baloonschall'].includes(exer.impl)) {
                        exerParams.couples = getSumSubSeries(exerParams);
                    } else if (['pathchall'].includes(exer.impl)) {
                        exerParams.series = generateChallNumberSeries(exerParams);
                    } else if (['multiplydivide'].includes(exer.impl)) {
                        exerParams.series = generateMultDivSeries(exerParams);
                    }

                } else if (['numberriddle'].includes(exer.impl)) {
                    [exerParams.series, exerParams.guess, exerParams.numbers] = generateTuples(exerParams);
                } else if (['completeoperations'].includes(exer.impl)) {
                    exerParams.series = generateCompleteEquationSeries(exerParams);
                } else if (['memomeshchallenge'].includes(exer.impl)) {
                    exerParams.series = generateAnimalsSeries(exerParams);
                } else if (['numericpath'].includes(exer.impl)) {
                    [exerParams.lItems, exerParams.lSolution, exerParams.llastPos] = generateNumPathSeries(exerParams);
                } else if (['equationchallenge'].includes(exer.impl)) {
                    exerParams.series = generateCompleteEquationsSeries(exerParams);
                }

                _chosenExercises.push(exer);
            }
        } else {
            _chosenExercises = _chosenExercises.filter(aEx => (!(aEx.label == exer.label && aEx.level == exer.level)));
        }

        _chosenExercises.sort((a, b) => a.level - b.level);
        // console.log(`handleExerciseChecked _chosenExercises:`, _chosenExercises);

        setChosenExercises(_chosenExercises);
    };

    const handleCheckClass = (aClass) => {
        setTheClass(aClass);
        setChosenExercises([]);
    }

    // console.log('CreateCompetition chosenExercises:', chosenExercises);

    if (classes && classes.length > 0) {
        return (
            <section className="create-class-form">
                <div className="form-group">
                    <Input
                        placeholder={t(lang, 'enterCompetitionName')}
                        value={competitionName}
                        onChange={(e) => setCompetitionName(e.target.value)}
                        autoComplete="off"
                        minLength={3}
                    />
                </div>
                <br />
                <br />

                <div className="form-group">
                    <h3>{t(lang, 'selectClass')}</h3>
                    <Radio.Group onChange={elem => handleCheckClass(elem.target.value)} value={theClass}>
                        {classes.map(aC => <Radio key={aC.id} value={aC}>{aC.name}</Radio>)}
                    </Radio.Group>
                </div>

                <br />
                <br />

                <div className="form-group">
                    <h3>{t(lang, 'selectExercises')}</h3>
                    <h5>{t(lang, 'maxExercises').replace('{{N}}', MAX_EXERCISES)}</h5>

                    <ul>
                        {chosenExercises.map(aE => <li key={`${aE.label}-${aE.level}`}>{t(lang, 'level')} {aE.level} - {t(lang, aE.label)}</li>)}
                    </ul>

                    {currentPlan ? <SelectExercises lang={lang} open={open} onClose={onClose} theClass={theClass} currentPlan={currentPlan} chosenExercises={chosenExercises} handleExerciseChecked={handleExerciseChecked} hasTeacherSubscription={hasTeacherSubscription} /> : null}

                    {theClass ? <Button className='button-white add' onClick={showDrawer}><PlusOutlined /></Button> : null}
                </div>

                <br />
                <br />

                <div className="button-group">
                    <Button type="primary" className="button-blue" onClick={handleCreate} disabled={!isValid}>
                        {t(lang, 'create')}
                    </Button>
                </div>
            </section >
        );
    } else return (
        <h3>{t(lang, 'classesMustExist')}</h3>
    );
};

export default CreateCompetition;